import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DesktopSidebarComponent } from "../../../../shared/components/desktop-sidebar/desktop-sidebar.component";
import { DesktopTopbarComponent } from "../../../../shared/components/desktop-topbar/desktop-topbar.component";
import { MobileTopbarComponent } from "../../../../shared/components/mobile-topbar/mobile-topbar.component";
import { TabButtonComponent } from "../../../../shared/components/tab-button/tab-button.component";
import { UploadedFileComponent } from "../../../auth/components/onboarding/uploaded-file/uploaded-file.component";
import { CommonModule } from '@angular/common';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { FolderInfo } from '../../../../core/interfaces/folder-info';
import { ToastComponent } from '../../../../shared/components/toast/toast.component';
import { FileUploadEnergyType, FileUploadFileType, UploadedFile } from '../../../../core/interfaces/file-upload-interfaces';
import { ReplaceFileDialogComponent } from '../../components/dialogs/replace-file-dialog/replace-file-dialog.component';
import { RecentUploadsService } from '../../../../core/services/recent-uploads.service';
import { FileUploadComponent } from "../../components/file-upload/file-upload.component";
import { CustomFooterComponent } from "../../../../shared/components/custom-footer/custom-footer.component";

@Component({
  selector: 'app-file-upload-overview',
  standalone: true,
  imports: [DesktopSidebarComponent, DesktopTopbarComponent, MobileTopbarComponent, TabButtonComponent, UploadedFileComponent, CommonModule, TranslocoPipe, ToastComponent, ReplaceFileDialogComponent, FileUploadComponent, CustomFooterComponent],
  templateUrl: './file-upload-overview.component.html',
  styleUrl: './file-upload-overview.component.css'
})
export class FileUploadOverviewComponent implements OnInit {
  selectedSidebarItemId: number = 12;

  isPaused: boolean = false;

  get listOfRecentUploads(): UploadedFile[] {
    return this.recentUploads.getLastUploads(10);
  }

  // List of folders
  numberOfFolders: number = 0;
  selectedFolder: number | undefined = undefined;

  // Toast
  @ViewChild(ToastComponent) toast!: ToastComponent;

  // Replace File dialog
  @ViewChild(ReplaceFileDialogComponent) replaceFileDialog!: ReplaceFileDialogComponent;

  constructor(private cdRef: ChangeDetectorRef, private translocoService: TranslocoService, private recentUploads: RecentUploadsService) { }

  ngOnInit(): void {
    // Set selected folder to All files
    this.selectedFolder = 0;

    this.cdRef.detectChanges();
  }

  // Triggers when a user clicks on one of the available folders
  selectFolderClick(folderId: number) {
    this.selectedFolder = folderId;
  }

  stopClicked(id: number) {
    if (!this.recentUploads.stopUpload(id)) {
      return;
    }

    this.toast.showToast(this.translocoService.translate("shared.file_upload.canceled"), this.translocoService.translate("shared.file_upload.stopped"), "warning", 4000, false);

  }

  // Warn user if trying to leave while upload is in progress
  @HostListener('window:beforeunload', ['$event'])
  preventNavigation(event: BeforeUnloadEvent) {
    var isUploading = this.recentUploads.hasPendingUploads();
    if (isUploading) {
      event.preventDefault();
    }
  }
}
